import React from 'react';
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import {useSelector} from "react-redux";
import {Col, Row} from "reactstrap";
import BBIconCompanyVerifiedCheck from "../../../assets/bbCustomIcons/BBIconCompanyVerifiedCheck";
import {bbFindEntityWithinPortfolioOrSelf} from "../../../util/bbHelpers";
import Skeleton from "react-loading-skeleton";

const BRCompanyScoreVerifiedBadge = ({
    entityId = null,
    hideDescription = false,
    fontSizeOverride= false,
    inline = false
                         }) => {


    const {customers, customerInView, loadingCustomers} = useSelector(({customer}) => customer);
    const { portfolios, entityInView, loadingPortfolios} = useSelector(({breachrisk}) => breachrisk);
    const entityIdToUse = entityId ? entityId : entityInView;
    //
    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    //
    const entity = bbFindEntityWithinPortfolioOrSelf(entityIdToUse, portfolios, customerIdToUse);

    const loading = !portfolios || (customerIdToUse && loadingPortfolios && loadingPortfolios[customerIdToUse]);

    // console.log("BRCompanyScoreVerifiedBadge", "entityId", entityId, "entityIdToUse", entityIdToUse, "customerIdToUse", customerIdToUse, "entity", entity);

    /*  jfd**********22.Dec.06.14:27*****
     *   Dec 2022 Verification
     *   Blue check verification is based on 3 prameters within the entity
     * account_active
     * active_subscription
     * verified
     *
     *   If all 3 are true, blue check
     *   If all true except verified, yellow check
     *   Otherwise, they are no check/grayed out check
         ********************** `--===<>==<>==C>-< */

    const isAccountActive = entity && entity.account_active;
    const isSubscriptionActive = entity && entity.active_subscription;
    const isOwnershipVerified = entity && entity.verified;
    
    let badgeDisplayText = ""
    let badgeDisplayColor = ""
    let badgeTooltipText = ""
    let hideBadge = false;


    //determine the values
    if(isAccountActive && isSubscriptionActive && isOwnershipVerified){
        //this is the fully verified case
        badgeDisplayText = "Verified"
        badgeDisplayColor = "text-electric-blue"
        badgeTooltipText = "This company has been fully verified. They have an active BreachRisk™ account and have proven ownership of this domain."
    } else if (isAccountActive && isSubscriptionActive && !isOwnershipVerified) {
        //they have an account with us, so useful for people to know
        badgeDisplayText = "Partial"
        badgeDisplayColor = "text-light-gray"
        badgeTooltipText = "This company has an active BreachRisk™ account but have not proven ownership of this domain."
    } else {
        //no stages of verification
        // badgeDisplayText = "Unverified"
        // badgeDisplayColor = "text-light-gray"
        // badgeTooltipText = "This company does not have an active BreachRisk™ account attribution of this BreachRisk™ Score cannot be guaranteed."
        hideBadge = true;
    }

    let badgeIcon = <BBIconCompanyVerifiedCheck
        style={{fontSize: fontSizeOverride ? fontSizeOverride : "2.5em"}}
        className={`mb-0 pb-0 ${badgeDisplayColor}`}
    />

    const badgeTooltip =[
        {icon: <BBIconCompanyVerifiedCheck
                        style={{fontSize: "2.5em"}}
                        className={`mb-0 pb-0 text-electric-blue`}/>,
        text: "Fully Verified with an active account"},
        {icon: <BBIconCompanyVerifiedCheck
                    style={{fontSize: "2.5em"}}
                    className={`mb-0 pb-0 text-light-gray`}/>,
        text: "Has an active account, not yet fully verified",}
    ]

    //     <div className={"m-1 p-2"}>
    //     {/*<Row>*/}
    //     {/*    <Col>*/}
    //     {/*        <p className={"text-center"}>A company that is fully verified through BreachBits will have verified ownership of their cyberspace and have an active account.</p>*/}
    //
    //     {/*    </Col>*/}
    //     {/*</Row>*/}
    //     <Row className={"text-center"}>
    //         <Col className={"align-self-center"} lg={2} sm={2}>
    //             <BBIconCompanyVerifiedCheck
    //                 style={{fontSize: fontSizeOverride ? fontSizeOverride : "2.5em"}}
    //                 className={`mb-0 pb-0 text-electric-blue`}/>
    //         </Col>
    //         <Col className={"text-left"}>
    //             Fully Verified with an active account
    //         </Col>
    //         <Col className={"align-self-center"} lg={2} sm={2}>
    //             <BBIconCompanyVerifiedCheck
    //                 style={{fontSize: fontSizeOverride ? fontSizeOverride : "2.5em"}}
    //                 className={`mb-0 pb-0 text-light-gray`}/>
    //         </Col>
    //         <Col className={"text-left"}>
    //             Has an active account, not yet fully verified
    //         </Col>
    //     </Row>
    // </div>

    const badge = <>
                <Tooltip extra={true} heading={"Subscription Status"} examples={badgeTooltip} width={"400px"}>
                    <span className={"text-center animated fadeIn animation-duration-7"}>
                        <Row>
                            <Col>
                                {badgeIcon}
                            </Col>
                        </Row>
                        {!hideDescription &&
                            <>
                                <Row>
                                    <Col style={{fontSize: "x-small"}}>
                                        {badgeDisplayText}
                                    </Col>
                                </Row>
                            </>
                        }
                        </span>
                     </Tooltip>
                    </>

    const badgeInline = <span className={"mx-1 animated fadeIn animation-duration-7"}>
        <Tooltip extra={true} heading={"Subscription Status"} examples={badgeTooltip} width={"400px"}>
                    <span>
                                {badgeIcon}
                        {!hideDescription &&
                            <span style={{fontSize: "x-small"}}>
                                        {badgeDisplayText}
                                    </span>

                        }
                        </span>
        </Tooltip>
    </span>

    if(loading){
        return null
    }else {
        return hideBadge ? null : inline ? badgeInline : badge;
    }


}

export default BRCompanyScoreVerifiedBadge;